import "babel-polyfill";

import serialize from './libs/serialize';

import colorFilterSwatches from './utils/color-filter-swatches';
import debounce from './utils/debounce';
import detectBreakpoint from './utils/detect-breakpoint';
import detectTouch from './utils/detect-touch';
import escape from './utils/escape';
import file from './utils/file';
import handleize from './utils/handleize';
import money from './utils/money';
import redirect from './utils/redirect';

import cart from './api/cart';
import product from './api/product';
import swatches from './api/swatches';

//
//  Utils
//  _____________________________________________

// if(!window.is_customize) redirect.init(); // Disable redirect for now to prevent redirecting to the UK site, might be needed later
debounce.init();
money.init();
detectBreakpoint.init();
detectTouch.init();
escape.init();
file.init();
handleize.init();
money.init();
colorFilterSwatches.init();

//
//  Libs
//  _____________________________________________

serialize.init();

//
//  Theme APIs
//  _____________________________________________

product.init();
cart.init();
swatches.init();

//
//  Web components
//  _____________________________________________

require('./components/header');
require('./components/variant-selector');
require('./components/component-swatches');
require('./components/quantity-selector');
require('./components/tab');
require('./components/related-products');
require('./components/modal');
require('./components/page-login');
require('./components/minicart');
require('./components/add-to-cart');
require('./components/cart-table');
require('./components/popup-modal');
require('./components/accordion');
require('./components/product-media');
require('./components/menu');
require('./components/product-single');
require('./components/search-bar');
require('./components/predictive-search');
require('./components/sort-by');
require('./components/page-account');
require('./components/page-addresses');
require('./components/interactive-banner');
require('./components/collection-filters');
require('./components/filters');
require('./components/login-flyout');
require('./components/view-password');
require('./components/price-component');
require('./components/component-quickview');
require('./components/component-quickview-trigger');
require('./components/product-association');
require('./components/product-color-disclaimer');
require('./components/page-register');
require('./components/load-more');
require('./components/collection-slider');
require('./components/collection-toolbar');
require('./components/collection-seo');
require('./components/product-recently-viewed');
require('./components/product-card');
require('./components/product-card-swatch-color');
require('./components/date-picker');
require('./components/showroom-nav');
require('./components/showroom-signup');
require('./components/showroom-quiz');
require('./components/showroom-join');
require('./components/showroom-event');
require('./components/showroom-bridal-persons');
require('./components/showroom-select-dresses');
require('./components/showroom-purchased-dresses');
require('./components/add-to-showroom');
require('./components/account-showrooms');
